import { supabase } from '@/core/database/supabase';
import type { 
  PerformanceSnapshot, 
  PerformanceAlert, 
  PerformanceFilters 
} from '../types/performance.types';

export const PerformanceService = {
  /**
   * Lấy danh sách snapshots hiệu suất
   */
  async getSnapshots(companyId: string, filters: PerformanceFilters): Promise<PerformanceSnapshot[]> {
    let query = supabase
      .from('construction_performance_snapshots')
      .select('*')
      .eq('company_id', companyId);

    if (filters.projectId) query = query.eq('project_id', filters.projectId);
    if (filters.scopeType) query = query.eq('scope_type', filters.scopeType);
    if (filters.periodType) query = query.eq('period_type', filters.periodType);
    
    if (filters.startDate) query = query.gte('period_start', filters.startDate);
    if (filters.endDate) query = query.lte('period_end', filters.endDate);

    const { data, error } = await query.order('generated_at', { ascending: false });

    if (error) {
      // Mock data if table doesn't exist yet
      return [
        {
          id: '1',
          company_id: companyId,
          project_id: filters.projectId || 'all',
          scope_type: 'team',
          scope_id: 't1',
          scope_name: 'Tổ thi công Cơ điện (MEP)',
          period_type: 'weekly',
          period_start: '2026-04-20',
          period_end: '2026-04-26',
          planned_work_orders: 25,
          completed_work_orders: 22,
          overdue_work_orders: 2,
          completion_rate: 88,
          progress_percent: 85,
          labor_productivity: 1.2,
          equipment_efficiency: 0.9,
          planned_cost: 450000000,
          actual_cost: 480000000,
          cost_variance_pct: 6.6,
          qa_pass_count: 18,
          qa_fail_count: 2,
          quality_score: 92,
          first_time_pass_rate: 85,
          rework_count: 1,
          rework_rate: 4,
          issue_count: 3,
          critical_issue_count: 0,
          resolved_issue_count: 3,
          average_resolution_hours: 12,
          overall_score: 89,
          rank_order: 1,
          generated_at: new Date().toISOString(),
          created_at: new Date().toISOString()
        }
      ];
    }
    return data as PerformanceSnapshot[];
  },

  /**
   * Lấy cảnh báo hiệu suất
   */
  async getAlerts(companyId: string, projectId: string): Promise<PerformanceAlert[]> {
    const { data, error } = await supabase
      .from('construction_performance_alerts')
      .select('*')
      .eq('company_id', companyId)
      .eq('project_id', projectId)
      .eq('status_code', 'open');

    if (error) return [];
    return data as PerformanceAlert[];
  },

  /**
   * Tổng hợp KPI thực tế (Aggregated from Work Orders, QA, etc.)
   */
  async getLiveKpis(companyId: string, projectId: string) {
    // Logic thực tế sẽ gọi RPC phức tạp
    return {
      activeWorkOrders: 45,
      overdueWorkOrders: 5,
      averageQaPassRate: 92.4,
      totalReworkCount: 8,
      costVariance: 2.5
    };
  }
};
